<template>
  <el-dialog :title="titleMsg" :visible.sync="showAppletSpecial.flag" width="700px" :close-on-click-modal="false"
    :close-on-press-escape="false" distroy-on-close append-to-body>
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px" class="form" size="small"
      :disabled="isDetail">
      <el-form-item label="活动类型：" prop="bizType">
        <el-select style="width: 100%;" v-model="ruleForm.bizType" placeholder="请选择活动类型" @change="activityTypeChange">
          <el-option v-for="item in activityData" :key="item.paramKey" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>
      <el-row v-if="ruleForm.bizType == 1">
        <el-col :span="24">
          <el-form-item label="关联直播：" prop="bizId">
            <load-select class="form-select" style="width: 100%;" v-model="ruleForm.bizId" dictLabel="name"
              dictValue="uuid" :data="bizData" :page="bizDataPage" :hasMore="bizDataMore" :request="getBizData"
              placeholder="请选择关联直播（输入名称以搜索）" :defaultVal="ruleForm.bizName" :isInit="isBizDataInit"
              @ChangeValue="bizIdChange" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else-if="ruleForm.bizType == 2">
        <el-col :span="24">
          <el-form-item label="关联预约：" prop="bizId">
            <load-select class="form-select" style="width: 100%;" v-model="ruleForm.bizId" dictLabel="name"
              dictValue="uuid" :data="bizData" :page="bizDataPage" :hasMore="bizDataMore" :request="getBizData"
              placeholder="请选择关联课程预约（输入名称以搜索）" :defaultVal="ruleForm.bizName" :isInit="isBizDataInit"
              @ChangeValue="bizIdChange" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else-if="ruleForm.bizType == 3">
        <el-col :span="24">
          <el-form-item label="关联考试：" prop="bizId">
            <load-select class="form-select" style="width: 100%;" v-model="ruleForm.bizId" dictLabel="name"
              dictValue="uuid" :data="bizData" :page="bizDataPage" :hasMore="bizDataMore" :request="getBizData"
              placeholder="请选择关联考试（输入名称以搜索）" :defaultVal="ruleForm.bizName" :isInit="isBizDataInit"
              @ChangeValue="bizIdChange" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="名称：" prop="name">
        <el-input placeholder="请输入名称" :maxlength="50" v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="图片：" prop="coverUrl" :rules="[rulesFactory.required('请上传图片')]">
        <div v-if="ruleForm.coverUrl" class="video-output" @mouseenter="showCover = true"
          @mouseleave="showCover = false">
          <img :src="ruleForm.coverUrl" class="avatar" />
          <div v-show="showCover" class="cover-bg">
            <i class="el-icon-zoom-in delete" @click.stop="handleShowViewer()"></i>
            <i v-if="!isDetail" class="el-icon-delete delete" @click.stop="deleteCoverApplet()"></i>
          </div>
        </div>
        <el-upload v-else action="" class="avatar-uploader" :show-file-list="false" :http-request="uploadCover"
          accept="png,jpg,jpeg" :limit="1" ref="coverUpload">
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <label v-if="!ruleForm.coverUrl" class="upload-text">上传图片</label>
        </el-upload>
        <div class="upload_tip">
          <p class="img_tip">建议尺寸：{{ imgSizeByType() }}</p>
        </div>
      </el-form-item>
      <el-form-item class="scale" label="显示时间：" prop="showType">
        <el-radio-group v-model="ruleForm.showType">
          <el-radio v-for="item in showDateTypeData" :key="item.paramKey" :label="item.paramKey">{{ item.paramValue
            }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="scale" prop="showDate" v-if="ruleForm.showType == 1">
        <el-date-picker unlink-panels v-model="ruleForm.showDate" type="datetimerange" range-separator="至"
          start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item class="scale" label="显示用户范围：">
        <div>{{ ruleForm.bizType == 3 ? '与考试名单一致' : '全部用户' }}</div>
      </el-form-item>
      <div v-if="ruleForm.bizType == 4 || ruleForm.bizType == 5">
        <el-form-item class="scale" label="跳转类型：" prop="skipType">
          <el-radio-group v-model="ruleForm.skipType" @change="skipTypeChange">
            <el-radio v-for="item in skipTypeData" :key="item.paramKey" :label="Number(item.paramKey)">{{
              item.paramValue
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row v-if="ruleForm.skipType == 1">
          <el-col :span="8">
            <el-form-item label="资源：" prop="resourceType">
              <el-select class="resourceType_style" v-model="ruleForm.resourceType" placeholder="请选择资源类型"
                @change="changeResourceType">
                <el-option v-for="item in resourceTypeData" :key="item.paramKey" :label="item.paramValue"
                  :value="Number(item.paramKey)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label-width="0px" prop="resourceId" :rules="[rulesFactory.required('请选择资源')]">
              <load-select v-if="ruleForm.resourceType == 0" style="width: 330px" v-model="ruleForm.resourceId"
                dictLabel="videoName" dictValue="uuid" :data="data" :page="page" :hasMore="more"
                :request="getResourceData" placeholder="请选择视频（输入视频名称关键字以查询）" :defaultVal="ruleForm.resourceName"
                :isInit="isInit" @change="sourceChange" />
              <load-select v-if="ruleForm.resourceType == 1" style="width: 330px" v-model="ruleForm.resourceId"
                dictLabel="name" dictValue="uuid" :data="data" :page="page" :hasMore="more" :request="getResourceData"
                placeholder="请选择图书（输入图书名称关键字以查询）" :defaultVal="ruleForm.resourceName" :isInit="isInit"
                @change="sourceChange" />
              <load-select v-if="ruleForm.resourceType == 2" style="width: 330px" v-model="ruleForm.resourceId"
                dictLabel="name" dictValue="uuid" :data="data" :page="page" :hasMore="more" :request="getResourceData"
                placeholder="请选择专题（输入专题名称关键字以查询）" :defaultVal="ruleForm.resourceName" :isInit="isInit"
                @change="sourceChange" />
              <load-select v-if="ruleForm.resourceType == 3" style="width: 330px" v-model="ruleForm.resourceId"
                dictLabel="name" dictValue="uuid" :data="data" :page="page" :hasMore="more" :request="getResourceData"
                placeholder="请选择新闻（输入新闻名称关键字以查询）" :defaultVal="ruleForm.resourceName" :isInit="isInit"
                @change="sourceChange" />
              <load-select v-if="ruleForm.resourceType == 4" style="width: 330px" v-model="ruleForm.resourceId"
                dictLabel="className" dictValue="uuid" :data="data" :page="page" :hasMore="more"
                :request="getResourceData" placeholder="请选择班级（输入班级名称关键字以查询）" :defaultVal="ruleForm.resourceName"
                :isInit="isInit" @change="sourceChange" />
              <load-select v-if="ruleForm.resourceType == 5" style="width: 330px" v-model="ruleForm.resourceId"
                dictLabel="name" dictValue="uuid" :data="data" :page="page" :hasMore="more" :request="getResourceData"
                placeholder="请选择文章（输入文章关键字以查询）" :defaultVal="ruleForm.resourceName" :isInit="isInit"
                @change="sourceChange" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="外链地址：" v-if="ruleForm.skipType == 0" prop="link" :rules="rulesFactory.required('请输入外部链接')">
          <el-input :placeholder="`请输入外部链接`" v-model="ruleForm.link"></el-input>
        </el-form-item>
        <el-form-item label="内链地址："  v-if="ruleForm.skipType == 2"  prop="link" :rules="rulesFactory.required('请选择跳转的内链地址')">
          <el-select v-model="ruleForm.link" placeholder="请选择跳转的内链地址" style="width: 100%">
            <el-option v-for="item in innerLinks" :key="item.paramKey" :label="item.paramValue"
              :value="item.paramKey"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="scale" label="第三方平台：" prop="clientOtherPlatformType" v-if="ruleForm.skipType == 3"
          :rules="[rulesFactory.required('请选择跳转的第三方平台')]">
          <el-select v-model="ruleForm.clientOtherPlatformType" placeholder="请选择跳转的第三方平台" style="width: 100%">
            <el-option v-for="item in platformTypeData" :key="item.paramKey" :label="item.paramValue"
              :value="Number(item.paramKey)"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDialog()" btntype title="取消"></butn>
      <butn v-if="!isDetail" btntype="primary" @click.native="sureSubmit()" title="确定"></butn>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer" :on-close="closeAppletViewer" :url-list="[ruleForm.coverUrl]" />
  </el-dialog>
</template>

<script>
import { getSysParamByTypes, getBusinessParamByTypes } from "@/api/sysParam";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import {
  saveClientIndexConfig,
  getArticleByName,
  clientIndexConfigInfo,
} from "@/api/resourceService";
import {
  getCourseTicketSelectPage,
  getLiveRoomSelectPage,
} from "@/api/liveRoom";
import { queryExamSelectPage } from "@/api/studyService";
import butn from "@/components/button/index";
import LoadSelect from "@/components/load-select/index.vue";
import { getBookByName } from "@/api/book";
import { getSelectClassList } from "@/api/class";
import { getNewsByName } from "@/api/news";
import { getSubjectByName } from "@/api/subjectInfo";
import { getVideoByName } from "@/api/video";
import moment from "moment";

export default {
  components: { butn, ElImageViewer, LoadSelect },
  props: {
    showAppletSpecial: {
      type: Object,
      default: function () {
        return {
          id: "",
        };
      },
    },
    clientType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rulesFactory,
      titleMsg: "新增",
      editFlag: false,
      activityData: [],
      skipTypeData: [], // 跳转类型（TYPE：BANNER_SKIP_TYPE  0外链 1资源 2内链 3第三方平台）
      resourceTypeData: [], // 资源类型（TYPE：BANNER_RESOURCE_TYPE  0视频 1图书 2专题 3新闻 4班级 5文章）
      platformTypeData: [], // 第三方平台类型（TYPE：CLIENT_OTHER_PLATFORM_TYPE  1中网院 2八八战略网上展厅）
      showDateTypeData: [],
      innerLinks: [],
      page: 1,
      more: true,
      data: [],
      showCover: false,
      showViewer: false,
      isInit: true,
      ruleForm: {
        name: "",
        resourceType: 0,
        bizId: null,
        skipType: 0,
        resourceId: "",
        link: "",
        clientOtherPlatformType: null,
        coverUrl: "",
        showType: '1',
        resourceName: "",
        showDate: [],
      },
      rules: {
        bizType: [rulesFactory.required("请选择活动类型")],
        bizId: [rulesFactory.required("请选择关联资源")],
        name: [
          rulesFactory.required("请输入名称"),
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        skipType: [rulesFactory.required("请选择跳转类型")],
        showType: [rulesFactory.required("请选择显示时间类型")],
        showDate: [rulesFactory.required("请选择指定时间")],
      },

      bizData: [],
      bizDataMore: true,
      isBizDataInit: true,
      bizDataPage: 1,

      isDetail: false
    };
  },
  created() {
    this.getBizTypeList();
    this.getSysParamByTypes([
      "BANNER_SKIP_TYPE",
      "BANNER_RESOURCE_TYPE",
      "CLIENT_OTHER_PLATFORM_TYPE",
      "INDEX_SHOW_TYPE",
      "INNER_LINK",
    ]);
    this.isDetail = this.showAppletSpecial.isDetail ? true : false;
    if (this.showAppletSpecial.id) {
      this.titleMsg = this.isDetail ? "详情" : "编辑";
      this.editFlag = true;
      // 处理编辑或者详情
      this.getConfigInfo();
    } else {
      this.titleMsg = "新增";
      this.editFlag = false;
    }
  },
  methods: {
    getBizTypeList() {
      let types = ['ACTIVITY_TYPE'];
      getBusinessParamByTypes({ types, clientType: this.clientType }).then((res) => {
        if (!res || res.code != 0) return;
        this.activityData = res.data["ACTIVITY_TYPE"]
      });
    },
    changeResourceType(val) {
      this.data = [];
      this.page = 1;
      this.more = true;
      this.ruleForm.resourceId = "";
      this.ruleForm.resourceName = "";
    },
    handleShowViewer() {
      this.showViewer = true;
    },
    // 特色内容配置详情-clc
    getConfigInfo() {
      clientIndexConfigInfo(this.showAppletSpecial.id).then((res) => {
        if (res.code !== 0) return;
        const { data = {} } = res;
        delete data.onlineStatus;
        delete data.deptId;
        delete data.deptLevelCode;
        delete data.order;
        let resp = {
          ...this.ruleForm,
          ...data,
          bizType: String(data.bizType),
          showType: String(data.showType),
          link: String(data.link || ''),
        };
        if (data.showType == 1) {
          resp.showDate = [data.showStartDate, data.showEndDate]
        }
        this.ruleForm = resp;
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.skipTypeData = res.data["BANNER_SKIP_TYPE"] || [];
        this.resourceTypeData = res.data["BANNER_RESOURCE_TYPE"] || [];
        this.platformTypeData = res.data["CLIENT_OTHER_PLATFORM_TYPE"] || [];
        this.showDateTypeData = res.data["INDEX_SHOW_TYPE"] || [];
        this.innerLinks = res.data["INNER_LINK"] || [];
        if (!this.editFlag) {
          this.ruleForm.resourceType = Number(
            this.resourceTypeData[2].paramKey
          );
          this.ruleForm.skipType = Number(this.skipTypeData[1].paramKey);
        }
      });
    },
    sourceChange() {
      this.isInit = false;
    },
    /**
     * 资源选择-
     */
    getResourceData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        let api = null
        let params = {
          name: keyword
        }
        switch (this.ruleForm.resourceType) {
          case 0: api = getVideoByName; break;
          case 1: api = getBookByName; break;
          case 2: api = getSubjectByName; break;
          case 3: {
            api = getNewsByName; 
            params = { newsTitle : keyword}
            break;
          }
          case 4: {
            api = getSelectClassList; 
            params = { className : keyword }
            break
          };
          case 5: {
            api = getArticleByName; 
            params = { articleTitle: keyword }
            break
          };
        }
        if (!api) return;
        api({ page, ...params })
          .then(({ code, data }) => {
            this.dealSource(more, code, data);
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    dealSource(more, code, data) {
      if (code !== 0) return;
      if (more) {
        this.data = [...this.data, ...data.records];
      } else {
        this.data = data.records;
      }
      this.page = data.current;
      let { current, total, size } = data;
      this.more = current * size < total;
      this.page = current;
    },
    // 上传WEB封面
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`configInfo/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.coverUrl = url;
      });
    },
    // 删除配图-小程序
    deleteCoverApplet() {
      this.ruleForm.coverUrl = "";
    },
    closeAppletViewer() {
      this.showViewer = false;
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    sureSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.name == "" || !this.ruleForm.name) {
            this.$message.warning('名称不能为空')
            return;
          }
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          delete params.showStartDate;
          delete params.showEndDate;
          delete params.showDate;
          if (this.ruleForm.showType == 1 && this.ruleForm.showDate && this.ruleForm.showDate.length > 0) {
            params.showStartDate = this.ruleForm.showDate[0];
            params.showEndDate = this.ruleForm.showDate[1];

          }
          if (params.bizType <= 3) {
            delete params.line;
            delete params.resourceId;
            delete params.resourceName;
            delete params.resourceType;
            delete params.skipType;
            delete params.clientOtherPlatformType;
          } else {
            delete params.bizId;
            delete params.bizName;
          }
          params.moduleType = 2;
          params.clientType = this.clientType;
          saveClientIndexConfig(params).then((res) => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 更新数据
              this.$emit("closeDialog", true);
            }
          });
        }
      });
    },

    activityTypeChange(val) {
      Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
      this.ruleForm.bizType = val;
       this.ruleForm.name = "";
      if (this.ruleForm.bizType == 1 || this.ruleForm.bizType == 2 || this.ruleForm.bizType == 3) {
        this.ruleForm.bizName = '';
        this.bizData = []
        this.bizDataMore = true
        this.isBizDataInit = true
        this.bizDataPage = 1
      }
      this.$refs.ruleForm.clearValidate();
    },
    /**
     * 关联直播，预约，考试，接口调用
     */
    getBizData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        let api = null
        if (this.ruleForm.bizType == 1) {
          api = getLiveRoomSelectPage
        } else if (this.ruleForm.bizType == 2) {
          api = getCourseTicketSelectPage
        } else if (this.ruleForm.bizType == 3) {
          api = queryExamSelectPage
        }
        if (!api) return;
        api({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.bizData = [...this.bizData, ...data.records];
            } else {
              this.bizData = data.records;
            }
            let { current, total, size } = data;
            this.bizDataMore = this.bizData.length < total;
            this.bizDataPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    bizIdChange(e) {
      this.isBizDataInit = false;
      if (!!e) {
        let item = this.bizData.filter((item) => item.uuid == e)[0];        
        this.ruleForm.name = item.name;
        if (this.ruleForm.bizType == 1) { //直播
          const startDate = moment(item.startDateStr).subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
          this.ruleForm.showDate = [startDate, item.endDateStr];
          return;
        } else if (this.ruleForm.bizType == 2) {
          this.ruleForm.coverUrl = item.coverUrl;
          this.ruleForm.showDate = [item.ticketStartDateStr, item.ticketEndDateStr];
        } else if (this.ruleForm.bizType == 3) {
          if (item.startDateStr && item.endDateStr) {
            this.ruleForm.showDate = [item.startDateStr, item.endDateStr];
          } else {
            this.ruleForm.showDate = [];
          }
        } else {
          this.ruleForm.showDate = [];
        }
      }
    },
    imgSizeByType() {
      const webFlag = this.clientType == 1 || this.clientType == 3;
      if (webFlag) {
        switch (Number(this.ruleForm.bizType)) {
          case 2:
          case 3: 
            return "2400px*280px";
          case 4:
            return "2400px*180px";
          case 5:
            return "2400px*180px";
          default:
            return "2400px*280px";
        }
      } else {
        switch (Number(this.ruleForm.bizType)) {
          case 1:
          case 2:
            return "1125px*632px";          
          case 3: 
          case 4:
            return "1029px*228px";
          case 5:
            return "1029px*228px";
          default:
            return "1125px*632px";
        }
      }
      
    },
    skipTypeChange() {
      this.$refs.ruleForm.clearValidate(["link", "resourceId", "clientOtherPlatformType"]);
      if  (this.ruleForm.skipType === 0 || this.ruleForm.skipType === 2) { 
        this.ruleForm.link = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;

/deep/ .el-dialog__body {
  max-height: 600px !important;
}

.resourceType_style {
  width: 100%;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px !important;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
</style>